import React from 'react';
import { Typography } from '@icecreamsocial/components';
import { Icon } from 'react-icons-kit';
import { ic_arrow_forward } from 'react-icons-kit/md/ic_arrow_forward';
import { ic_card_giftcard } from 'react-icons-kit/md/ic_card_giftcard';
import { ic_content_copy } from 'react-icons-kit/md/ic_content_copy';
import { ic_lock_open } from 'react-icons-kit/md/ic_lock_open';
import { ic_share } from 'react-icons-kit/md/ic_share';
import { ic_sms } from 'react-icons-kit/md/ic_sms';
import { ic_email } from 'react-icons-kit/md/ic_email';
import { ic_close } from 'react-icons-kit/md/ic_close';
import { ic_note_add } from 'react-icons-kit/md/ic_note_add';
import { facebookOfficial } from 'react-icons-kit/fa/facebookOfficial';

/**
 * @module SupportedIcons
 * @category Components
 * @subcategory Presentational
 * @description
 * This file can be narrowed down to just one generic icon component, but doing this for convenience.  It does make the bundle a bit bigger and doesn't take advantage of code splitting
 * but the semantics and readability of it are very useful.  it will also give us a single point for changing icons in case we want to switch later on.
 */

/**
 * @typedef IconSize
 * @property {number} [size = 24] the icon size
 */

/**
 * @param {module:SupportedIcons~IconSize} props
 * @description
 * A + icon.
 * @component
 * @example
 * return (<GiftCard size={36}/>)
 * @todo
 * document this and the other icons
 */
export const GiftCardIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_card_giftcard}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const FacebookIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={facebookOfficial}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const CopyIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_content_copy}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const UnlockIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_lock_open}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const RightArrowIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_arrow_forward}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const ShareIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_share}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const SmsIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_sms}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const EmailIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_email}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const CloseIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_close}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);

export const AddNoteIcon = ({ size = 24, ...rest }) => (
	<Typography.Span
		as={Icon}
		icon={ic_note_add}
		size={size}
		typoWeight={'bold'}
		display="inline-flex !important"
		alignItems="center"
		{...rest}
	/>
);
